import { render, staticRenderFns } from "./especialidades_admin.vue?vue&type=template&id=b704d2b6&scoped=true&"
import script from "./especialidades_admin.vue?vue&type=script&lang=js&"
export * from "./especialidades_admin.vue?vue&type=script&lang=js&"
import style0 from "./especialidades_admin.vue?vue&type=style&index=0&id=b704d2b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b704d2b6",
  null
  
)

export default component.exports